export const BASE_LABEL = 'absolute left-0 right-0 top-0 z-0 inline-flex';

export const HINT = 'opacity-80 mr-16 overflow-hidden';

export const FLOATING = 'opacity-64';

export const FLOATING_DISABLED = 'opacity-56';
